"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var react_select_1 = __importDefault(require("react-select"));
var creatable_1 = __importDefault(require("react-select/creatable"));
var SelectOption_1 = __importDefault(require("./SelectOption"));
var SelectMenuList_1 = __importDefault(require("./SelectMenuList"));
var Select = function (_a) {
    var loading = _a.loading, editable = _a.editable, multiselect = _a.multiselect, onClickEditOption = _a.onClickEditOption, options = _a.options, value = _a.value, other = __rest(_a, ["loading", "editable", "multiselect", "onClickEditOption", "options", "value"]);
    var theme = styles_1.useTheme();
    // const ref = useRef();
    var styles = {
        valueContainer: function (provided) { return (__assign(__assign({}, provided), { padding: 0, border: 'none' })); },
        container: function (provided) { return (__assign(__assign({}, provided), { padding: 0, border: 'none' })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { padding: 0, border: 'none', zIndex: 9999 })); },
        option: function (provided) { return (__assign(__assign({}, provided), { cursor: 'pointer', padding: 20, fontFamily: theme.typography.fontFamily })); },
        control: function (provided) { return (__assign(__assign({}, provided), { cursor: 'pointer', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', fontFamily: theme.typography.fontFamily, fontSize: '20px' })); },
        indicatorSeparator: function () { return ({ display: 'none' }); },
        placeholder: function (provided) { return (__assign(__assign({}, provided), { fontFamily: theme.typography.fontFamily })); },
    };
    var props = __assign({ maxMenuHeight: 300, isClearable: true, 
        // ref,
        styles: styles,
        editable: editable, isMulti: multiselect, isLoading: loading, options: options,
        onClickEditOption: onClickEditOption,
        value: value, components: {
            MenuList: SelectMenuList_1.default,
            Option: SelectOption_1.default,
        } }, other);
    if (editable) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return react_1.default.createElement(creatable_1.default, __assign({}, props));
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return react_1.default.createElement(react_select_1.default, __assign({}, props));
};
exports.default = Select;
//# sourceMappingURL=Select.js.map